import { ReceiveStatusHistory } from "../../common/Receive";
import { receiveFailureReasonToInstruction, receiveFailureReasonToLabelMapping } from "../../util/receiveFailureReason";
import { canBeFinalisedStatusList, receiveStatus } from "../../util/receiveStatus";
import { AlertInformation } from "../AlertInformation/AlertInformation";

export type ReceiveFailureAlertProps = {
	status: string;
	failureReason?: string | null;
	hours?: number;
	receiptAttemptCount?: number;
	latestStatusHistory?: ReceiveStatusHistory;
};
export default function ReceiveFailureAlert(props: ReceiveFailureAlertProps) {
	const { failureReason, hours, status, latestStatusHistory } = props;
	const shouldAlertShow = (() => {
		const hasFailureReason = failureReason != null && failureReason.length > 0;
		const isFinalisableStatus = canBeFinalisedStatusList.includes(status);
		const isPendingFinaliseWithDelay =
			status === receiveStatus.pendingFinalise &&
			latestStatusHistory?.status === receiveStatus.pendingFinalise &&
			latestStatusHistory.timestamp &&
			new Date().getTime() - Date.parse(latestStatusHistory.timestamp) > 5 * 60 * 1000;

		return (hasFailureReason && isFinalisableStatus) || isPendingFinaliseWithDelay;
	})();
	return shouldAlertShow ? (
		<AlertInformation
			severity="warning"
			message={receiveFailureReasonToInstruction(failureReason ?? "")}
			title={receiveFailureReasonToLabelMapping(failureReason ?? "", hours ?? 0)}
		/>
	) : (
		<></>
	);
}
